import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../../theme';

import {Dialog, DialogActions, DialogContent, DialogTitle, Typography} from '@material-ui/core'
import {Container, Box, Grid} from '@material-ui/core'
import {Button, OutlinedInput} from '@material-ui/core';
import { SortableTable } from '../../../../components/SortableTable';
import { formatDateTime } from '../../../../api/date';


class RecordPlayer_ extends React.Component{

    constructor(props){
        super(props)

        console.log('RecordPlayer constructor')
        console.log('props')
        console.log(props)
        this.state = {
            //properties: props.properties,
            currentItem: null,
            url: null,
            filename: null,
            autoplay: false
        }


        this.handleResourceGet = this.handleResourceGet.bind(this)
        this.next = this.next.bind(this) 

        this.onRecordClick = this.onRecordClick.bind(this)
        this.onRecordDoubleClick = this.onRecordDoubleClick.bind(this)
    }

    componentDidMount(){
        this.autoplay(0)
    }
    

    autoplay(index){
        console.log('autoplay')

        if(this.props.records && this.props.records.length>0){
            this.setState({autoplay:'autoplay'})
            this.play(index)
            /*
            let row = this.props.records[0]
            console.log('autoplay')
            console.log(row)

            this.props.onAction({type: 'RESOURCE_GET', row: row, onComplete: this.handleResourceGet })

            this.setState({currentItem: 0})
            */
        }

    }

    next(){
        //console.log(this.state)
        //alert('Next ' + (this.state.currentItem+1))
        console.log('next ' +(this.state.currentItem+1)  )
        this.play(this.state.currentItem+1)
    }

    play(index){

        if(index > this.props.records.length-1){
            this.setState({autoplay: false})
            return
        } 

        let row = this.props.records[index]
        console.log('play')
        console.log(row)

        if(row.url && row.filename){
            this.setState({url: row.url, filename: row.filename, currentItem: index})
        }else{
            this.props.onAction({type: 'RESOURCE_GET', row: row, onComplete: this.handleResourceGet })
            this.setState({currentItem: index})
        }
    }

    handleResourceGet(url, filename){
        console.log('url')
        console.log(url)
        

        let row = this.props.records[this.state.currentItem]
        row.url = url
        row.filename = filename

        //alert('handleResourceGet')
        this.setState({url:url, filename: filename})
    }

    
    handleClose(){
        if(this.state.changed){
            if(!window.confirm(this.props.t('CloseFormConfirm'))) return; 
        }
        this.props.onAction({type: 'RESOURCE_PLAY_CLOSE'})
    }

    onRecordClick(row, index){
        //alert('click '+index)

        this.setState({currentItem: index, filename: row.filename, url: row.url})
        //let records = this.props.records.map((item, idx)=>({...item, selected:index===idx }) )
        
    }

    onRecordDoubleClick(row, index){
        //alert('dblClick '+index)
        this.setState({currentItem: index, filename: row.filename, url: row.url})
        this.play(index)
    }

    renderRecordsTable(currentItem){
        let t = this.props.t

        console.log('renderRecordsTable')
        console.log(this.props)

        let records = this.props.records.map((item, index)=>({...item, selected:index===currentItem }) )

        let columns = [
            {
                label: t('DateTime'),
                name: 'edt',
                eval: (val)=>{return formatDateTime(val, 'full_date')}
            },
            {
                label: t('Source'),
                name: 'fromname'
            },
            {
                label: t('Destination'),
                name: 'toname'
            },
            {
                label: t('Duration_s'),
                name: 'duration'
            }
        ]

        return (
            <SortableTable 
                t={t}
                rows={records} 
                columns={columns}
                version={this.props.version+currentItem}
                primaryKey="euuid"
                onRowClick={this.onRecordClick}
                onRowDoubleClick={this.onRecordDoubleClick}
            />
        )

    }

    render(){

        const {t} = this.props

        const title = t('RecordPlayer')

        return (

<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose.bind(this)}
    aria-labelledby="properties-dialog-title">
        
    <DialogTitle id="properties-dialog-title">{title}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:500}}>

            {this.renderRecordsTable(this.state.currentItem)}

            <Box>
                <audio src={this.state.url} 
                    autoplay={this.state.autoplay} 
                    style={{width:500}} 
                    controls={true}
                    onEnded={this.next}
                />
            </Box>

            <Box>
            <a download={this.state.filename} href={this.state.url} >{this.state.filename}</a>
            </Box>
        
        </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleClose.bind(this)} variant="contained" color="inherit">
            {t('Close')}
        </Button>
    </DialogActions>

</Dialog>

        )

    }

}


export const RecordPlayer = withTranslation()(RecordPlayer_);